import BookLibrarySerializer from 'teacher-ui-client/mirage/serializers/book-library/book-library'

export default BookLibrarySerializer.extend({})
